var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("backup")))]),
                      !_vm.hasModule
                        ? _c(
                            "w-card-content",
                            [
                              _c("app-missing-module", {
                                attrs: { "module-id": _vm.moduleId },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "w-list",
                            [
                              _c(
                                "w-list-item",
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$ct("create-backup")) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "w-list-item-action",
                                    [
                                      !_vm.isCreatingBackup
                                        ? _c(
                                            "w-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isRunningBackupTask ||
                                                  !_vm.canCreateBackup,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.createBackup()
                                                },
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "play" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("w-progress-circular", {
                                            attrs: { small: "" },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$ct("restore-backup")) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "w-list-item-action",
                                    [
                                      !_vm.isRestoringBackup
                                        ? _c(
                                            "w-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.isRunningBackupTask,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.restoreBackup()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$ct("choose-file")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c("w-progress-circular", {
                                            attrs: { small: "" },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item",
                                [
                                  _c("w-list-item-text", [
                                    _vm._v(
                                      _vm._s(_vm.$ct("automatic-backups"))
                                    ),
                                  ]),
                                  _c(
                                    "w-list-item-action",
                                    [
                                      _c("w-switch", {
                                        attrs: {
                                          value: _vm.automaticBackupsEnabled,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.toggleAutomaticBackups(
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [_c("app-previous-backups")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.restoreBackupModal
        ? _c(
            "w-modal",
            { attrs: { value: _vm.restoreBackupModal } },
            [
              _c("app-restore-backup-modal", {
                on: {
                  close: function ($event) {
                    _vm.restoreBackupModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.creatingBackupModal
        ? _c(
            "w-modal",
            { attrs: { value: true } },
            [
              _c("app-creating-backup-modal", {
                on: {
                  close: function ($event) {
                    _vm.creatingBackupModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }